import { Api } from '@/services/Api';

export default {
  getEnergyGraph(plantId, startDate, endDate) {
    return Api().post(`/api/v2/pvsyst/graph/energy`, {plantId,startDate,endDate});
  },
  getInsoGraph(plantId, startDate, endDate) {
    return Api().post(`/api/v2/pvsyst/graph/insolation`, {plantId,startDate,endDate});
  },
  getDailytabledata(plantId) {
    return Api().get(`/api/v2/pvsyst/table/daily/${plantId}`);
  },
  getMonthstableData(plantId) {
    return Api().get(`/api/v2/pvsyst/table/monthly/${plantId}`);
  },
  loadTableData(plantId) {
    return Api().get(`/api/v2/pvsyst/upload-history/${plantId}`);
  },
  getPresignedUrl(plantId, fileName) {
    return Api().get(`/api/v2/pvsyst/presigned-url/${plantId}/${fileName}`);
  },
  downloadTemplate() {
    return Api().get("/api/v2/pvsyst/download-template");
  },
  submitForm(plantId, year, formData, headers) {
    return Api().post(`/api/v2/pvsyst/upload/${plantId}/${year}`, formData, {
      headers
    });
  }
};

